import { render } from "./StatAge.vue?vue&type=template&id=169474a3&scoped=true&ts=true"
import script from "./StatAge.vue?vue&type=script&lang=ts"
export * from "./StatAge.vue?vue&type=script&lang=ts"

import "./StatAge.vue?vue&type=style&index=0&id=169474a3&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169474a3"]])

export default __exports__